import React, { useEffect, useState } from 'react'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import {
  getIsActiveDate,
  getIsActivePage
} from '@toasttab/shared/src/utils/bannerUtils'
import { GlobalBannerData } from './GlobalBanner.d'

const GlobalBanner = () => {
  const [activeBanner, setActiveBanner] = useState(null)
  const { globalSettings, activeGlobalBanner, region, setActiveGlobalBanner } =
    usePageContext()

  useEffect(() => {
    // Filter to active entries only for the correct region
    const activeBannerData = globalSettings?.globalBanner?.filter(
      ({ activePages, country, endDate, startDate }: GlobalBannerData) =>
        country === region &&
        getIsActiveDate(startDate, endDate) &&
        getIsActivePage(activePages)
    )

    // If we have an active banner, save the first one in state
    if (activeBannerData?.length > 0) {
      setActiveBanner(activeBannerData[0])
    }
  }, [globalSettings?.globalBanner, region, setActiveBanner])

  useEffect(() => {
    if (activeBanner && activeBanner.contentful_id !== activeGlobalBanner) {
      // Save active banner ID to global context
      setActiveGlobalBanner(activeBanner.contentful_id)
    }
  }, [activeBanner, activeGlobalBanner, setActiveGlobalBanner])

  return (
    <>
      {activeBanner && (
        <div
          className='bg-blue-0 text-center md:h-10 min-h-[40px] text-base'
          data-testid='GlobalBanner'
        >
          <a
            className='md:flex justify-center items-center h-full'
            data-testid='GlobalBanner-link'
            href={activeBanner.cta?.url}
          >
            <strong className='font-sansPro font-semibold text-black tracking-[.2px]'>
              {renderRichText(activeBanner.heading)}
            </strong>
            {activeBanner.subheading?.raw && (
              <TextLink
                classes='ml-2 md:ml-8'
                el='span'
                icon='arrowRight'
                text={renderRichText(activeBanner.subheading) as string}
              />
            )}
          </a>
        </div>
      )}
    </>
  )
}

export default GlobalBanner
